export const STORELIST = [
  {
    type: 'TAOBAO',
    img: 'tbplat',
    icon_circle: 'icon_taobao',
    name: '淘宝',
    hasOrderService: true, // 订购服务
  }, {
    type: 'PDD',
    img: 'pddplat',
    icon_circle: 'icon_pingduoduo',
    name: '拼多多',
    hasOrderService: true, // 订购服务
  }, {
    type: 'LUBAN',
    img: 'dyplat',
    icon_circle: 'icon_douyin',
    name: '抖音',
    hasOrderService: true,
  }, {
    type: 'KS',
    img: 'ksplat',
    icon_circle: 'icon_kuaishou',
    name: '快手',
    hasOrderService: true,
  }, {
    type: 'JD',
    img: 'jdplat',
    icon_circle: 'icon_jingdong',
    name: '京东',
    hasOrderService: true
  }, {
    type: 'ALI_1688',
    img: '1688plat',
    icon_circle: 'icon_1688',
    name: '1688',
    hasOrderService: true
  }, {
    type: 'WXSPH',
    img: 'wxsphplat',
    icon_circle: 'icon_wxsph',
    name: '微信小店',
    hasOrderService: true
  }, {
    type: 'DYDF',
    img: 'dydfplat',
    icon_circle: 'icon_douyin_dyfa',
    name: '抖音厂商',
    hasOrderService: true
  }, {
    type: 'YZ',
    img: 'yzplat',
    icon_circle: 'icon_youzan',
    name: '有赞',
    hasOrderService: true,
  }, {
    type: 'SN',
    img: 'snplat',
    icon_circle: 'icon_suning',
    name: '苏宁',
    hasOrderService: true,
  }, {
    type: 'WD',
    img: 'wdplat',
    icon_circle: 'icon_weidian',
    name: '微店',
    hasOrderService: false,
  },
  // {
  //   type: 'JP',
  //   img: 'juanpi',
  //   icon_circle: 'icon_juanpi',
  //   name: '卷皮',
  //   hasOrderService: false
  // },
  // {
  //   type: 'GOME',
  //   img: 'guomei',
  //   icon_circle: 'icon_guomei',
  //   name: '国美',
  //   hasOrderService: false,
  // },
  // {
  //   type: 'MGJ',
  //   img: 'mogujie',
  //   icon_circle: 'icon_mogujie',
  //   name: '蘑菇街',
  //   hasOrderService: false,
  // },
  {
    type: 'XIAOHS',
    img: 'xhsplat',
    icon_circle: 'icon_xiaohongshu',
    name: '小红书',
    hasOrderService: false
  },
  // {
  //   type: 'BEIBEI',
  //   img: 'beibeiplat',
  //   icon_circle: 'icon_beibei',
  //   name: '贝贝',
  //   hasOrderService: false
  // },
  {
    type: 'DEWU',
    img: 'dwplat',
    icon_circle: 'icon_dewu',
    name: '得物',
    hasOrderService: true,
  },
  {
    type: 'BLBL',
    img: 'blblplat',
    icon_circle: 'icon_blbl',
    name: '哔哩哔哩',
    hasOrderService: false,
  },
  {
    type: 'WXGYS',
    img: 'wxgysplat',
    icon_circle: 'icon_wxsph',
    name: '微信供货商',
    hasOrderService: false,
  },
]
export const PLATFORMICONMAP = {
  TAOBAO: 'icon_taobao',
  PDD: 'icon_pingduoduo',
  PDDKJ: 'icon_pingduoduo',
  LUBAN: 'icon_douyin',
  KS: 'icon_kuaishou',
  JD: 'icon_jingdong',
  ALI_1688: 'icon_1688',
  DYDF: 'icon_douyin_dyfa',
  PDDDF: 'icon_pdddf',
  YZ: 'icon_youzan',
  SN: 'icon_suning',
  WD: 'icon_weidian',
  JP: 'icon_juanpi',
  GOME: 'icon_guomei',
  MGJ: 'icon_mogujie',
  XIAOHS: 'icon_xiaohongshu',
  BEIBEI: 'icon_beibei',
  ZDYDY: 'icon_dayin', // 自定义打印
  DSFPT: 'icon_ziyoudayin', // 第三方平台
  RUYI: 'icon_ruyi', // 如意家生活
  YUANLAIHUI: 'icon_yuanlaihui', // 缘莱荟
  WXSPH: 'icon_wxsph', // 微信小店
  DEWU: 'icon_dewu', // 得物
  BLBL: 'icon_blbl', // 哔哩哔哩
  WXGYS: 'icon_wxsph', // 微信供货商
}
export const PLATFORMNAMEMAP = {
  TAOBAO: '淘宝',
  PDD: '拼多多',
  PDDKJ: '拼多多跨境',
  LUBAN: '抖音',
  KS: '快手',
  JD: '京东',
  ALI_1688: '1688',
  DYDF: '抖音厂商',
  PDDDF: '拼多多代发',
  YZ: '有赞',
  SN: '苏宁',
  WD: '微店',
  JP: '卷皮',
  GOME: '国美',
  MGJ: '蘑菇街',
  XIAOHS: '小红书',
  BEIBEI: '贝贝',
  RUYI: '如意家生活',
  WXSPH: '微信小店',
  DEWU: '得物',
  BLBL: '哔哩哔哩',
  WXGYS: '微信供货商',
}
// 面单类型名称映射
export const WAYBILLNAMEMAP = {
  YTO: '普通电子面单',
  CN: '菜鸟电子面单',
  TAOBAO: '淘宝电子面单',
  ALI_1688: '1688电子面单',
  PDD: '拼多多电子面单',
  JD: '京东电子面单',
  KS: '快手电子面单',
  LUBAN: '抖音电子面单',
  YTO_ZD: '圆准达电子面单',
  XIAOHS: '小红书电子面单',
  WXSPH: '腾讯电子面单',
  DEWU: '得物电子面单',
  WXGYS: '腾讯电子面单',
  BLBL: '普通电子面单',
}
// 快递公司名称映射
export const CPCODEMAP = {
  yuantong: '圆通速递',
  YTO: '圆通速递',
  ZTO: '中通速递',
  STO: '申通快递',
  YUNDA: '韵达快递',
  SF: '顺丰速运',
  EMS: 'EMS',
  YZKDBG: '邮政快递包裹',
  JD: '京东物流',
  JT: '极兔速递',
  BEST: '百世快递'
}
// 旗帜颜色映射
export const FLAGSCOLORMAP = {
  GREY: '#A2A5AC', 
  RED: '#F35252', 
  YELLOW: '#E6A733', 
  GREEN: '#3BB950', 
  BLUE: '#4CA0FF', 
  PURPLE: '#7A52E6', 
}
